module.exports = __webpack_public_path__ + "static/media/Pin_Point_Img.9e9ce790.png";